import Tooltip from '@mui/material/Tooltip';
import { Icon } from '../theme/Icon';
import s from './InfoTip.module.css';
import { t } from '@app/i18n';

export interface InfoTipProps {
  /** Explicação exibida. Texto herdado do inventário do protótipo (FR-132). */
  text: string;
  /** Rótulo acessível do gatilho. Padrão: "Explicação". */
  label?: string;
  size?: 'xs' | 'sm';
  className?: string;
}

/**
 * Ícone ⓘ com explicação (FR-132) — obrigatório em toda linha de status e todo
 * campo de configuração. Acessível por teclado (é um `<button>`).
 *
 * O `aria-label` é o NOME do gatilho («Explicação», «Sobre o estado do PDP») e
 * não carrega a explicação. Quem descreve é o `describeChild` do MUI, e ele muda
 * de mecanismo conforme o estado: com o balão ABERTO põe `aria-describedby`
 * apontando para o balão e tira o `title`; com o balão FECHADO põe o texto no
 * `title`. Nenhum dos dois é escrito aqui — os dois vêm do `Tooltip`.
 *
 * **Não acrescente `aria-description` (ARIA 1.3).** Foi tentado em 12/09 e o
 * `eslint-plugin-jsx-a11y` reprova (`role-supports-aria-props`: o atributo não é
 * suportado pelo papel `button`), com o `make gate-full` vermelho. A decisão de
 * 13/09 foi remover em vez de silenciar a regra: um `eslint-disable` compraria
 * um atributo que poucos leitores anunciam ao preço de cegar a guarda para o
 * resto do ficheiro. Se um dia a tabela do plugin passar a aceitá-lo, o caminho
 * é atualizar o plugin, não a escotilha.
 *
 * `__tests__/InfoTip.test.tsx` afirma o ATRIBUTO em cada estado, e não a
 * descrição acessível: `title` e `aria-describedby` produzem a MESMA frase, logo
 * `toHaveAccessibleDescription` fica verde sem distinguir qual deles trabalhou.
 */
export function InfoTip({
  text,
  label = t('common.ui.infoTip'),
  size = 'sm',
  className,
}: InfoTipProps) {
  return (
    <Tooltip title={text} arrow enterTouchDelay={0} describeChild>
      <button
        type="button"
        className={[s.tip, className].filter(Boolean).join(' ')}
        aria-label={label}
        // O ⓘ EXPLICA; ele nunca faz a ação de quem está à volta. Dentro de uma
        // `DataTable` com `onRowClick` — Sites e Auditoria, desde 14/09 — o clique
        // que abre o balão subiria para a linha e abriria a gaveta por cima da
        // explicação que a pessoa acabou de pedir. Num toque é pior: o balão abre no
        // `enterTouchDelay={0}` e a tela muda debaixo dele.
        onClick={(event) => event.stopPropagation()}
      >
        <Icon name="info" size={size} />
      </button>
    </Tooltip>
  );
}
